import { ColumnModel, ConfigHeader, DataModel, FusionEntity, ReferenceTableModel, TableModel, User } from '@shared';

/* eslint-disable @typescript-eslint/naming-convention */
export interface ExportJSONFileModel {
	FileName: string;
	FusionEntities: FusionEntity[];
	FusionDataColumns: ColumnModel[];
	FusionDataTables: TableModel[];
	TABLE_DATA: DataModel[];
	FusionReferenceTables: ReferenceTableModel[];
	FusionUsers: User[];
	FusionConfigHeader: ConfigHeader[];
}
